import { HttpRequest as LegacyHttpRequest } from './ajaxrequest.legacy';
export { AjaxException } from './ajaxrequest.legacy';
export class AjaxRequestClass {
    awaitRawResponse(method, url, bodyParams, headers, timeout) {
        return new Promise((resolve, reject) => {
            LegacyHttpRequest.requestRawXHR(method, url, bodyParams, headers, resolve, reject);
        });
    }
    request(method, url, bodyParams, headers, timeout) {
        return new Promise((resolve, reject) => {
            LegacyHttpRequest.request(method, url, bodyParams, headers, resolve, reject);
        });
    }
    send(url, headers) {
        return new Promise((resolve, reject) => {
            LegacyHttpRequest.send(url, headers, resolve, reject);
        });
    }
    post(url, params, headers) {
        return new Promise((resolve, reject) => {
            LegacyHttpRequest.post(url, params, headers, resolve, reject);
        });
    }
}
export const HttpRequest = new AjaxRequestClass();
